import { providers } from "ethers";
import { RESTAPI, _web3Modal } from "../config";

export default class Wallet {
  /**
   * Connect wallet
   *
   * @returns Promise
   */
  static async connectWallet() {
    try {
      const _provider = await _web3Modal.connect();

      const _web3Provider = new providers.Web3Provider(_provider);
      const network_id = await _web3Provider.send("net_version");
      const address = await _web3Provider.getSigner().getAddress();

      RESTAPI.connectWallet(address);

      return {
        network_id,
        address,
      };
    } catch ({ message }) {
      return { status: false, message };
    }
  }
}
